<template>
    <div v-if="companyLogo" class="logo">
        <img
            class="logo-img"
            :src="companyLogo"
            :alt="companyName"
            :title="companyName"
        />
    </div>
</template>

<script>
export default {
    props: {
        companyLogo: String,
        companyName: String,
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common';

.logo {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.logo-img {
    max-width: px-to-rem(400px);
    max-height: px-to-rem(62px);
}

@media($small) {
    .logo-img {
        max-width: 100%;
    }
}
</style>
